/* istanbul ignore file */
import type { AppProps } from 'next/app'
import '../styles/globals.css'
import React, { useEffect } from 'react'
import { SWRConfig } from 'swr'
import { useRouter } from 'next/router'
import { trackPageView } from '../utils/gtag'

const MyApp = ({ Component, pageProps }: AppProps) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: URL) => {
      trackPageView(url);
    };

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return (
    <SWRConfig
      value={{
        refreshInterval: 10000,
        fetcher: (resource, init) => fetch(resource, init).then(async res => {
          if (!res.ok) {
            const error = new Error('An error occurred while fetching the data.') as any
            error.info = await res.json()
            error.status = res.status
            throw error
          }
          return res.json()
        })
      }}
    >
      <Component {...pageProps} />
    </SWRConfig>
  )
}

export default MyApp
